import { render, staticRenderFns } from "./SemenStorage.vue?vue&type=template&id=1b663734&scoped=true&"
import script from "./SemenStorage.vue?vue&type=script&lang=js&"
export * from "./SemenStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b663734",
  null
  
)

export default component.exports